import { getISOTimzoneFSSafeString } from './date.utils';
import { inline_ } from './string.utils';

type _FileSafeSlug = string & { __brand :'FileSafeSlug' };

const _FILE_SAFE_CHAR = '[a-zA-Z0-9_-]';
const _FILE_SAFE_SLUG_REGEX = new RegExp(`^${_FILE_SAFE_CHAR}+$`);
const _FILE_SAFE_CHAR_REGEX = new RegExp(_FILE_SAFE_CHAR, 'g');

const _isFileSafeSlug = (value :string) :value is _FileSafeSlug =>
  _FILE_SAFE_SLUG_REGEX.test(value);

export const lumFileName = (
  slug :_FileSafeSlug | string,
  extension ?:`.${string}`,
) :string => {
  if (!_isFileSafeSlug(slug)) {
    const invalidChars = slug.replace(_FILE_SAFE_CHAR_REGEX, '');

    throw new Error(
      inline_`Invalid 'slug': Only hyphens, underscores, and alphanumeric
      chars are allowed (invalid char(s): ${JSON.stringify(invalidChars)}).`,
    );
  }

  return `luminous-${slug}-${getISOTimzoneFSSafeString()}${extension ?? ''}`;
};
